import React from 'react';
import SemDados from '../SemDados';
import '../styles.scss';
import { NOME_PROJETO } from '../const';

const MaterialInvestimentoTabela = (props) => {
  const { data } = props;
  const titulo = `INVESTIMENTO ${NOME_PROJETO} - MATERIAL COMUNICAÇÃO`;

  if (!data || data.length < 1) {
    return <SemDados titulo={titulo} />;
  }

  const formatarValor = (valor) => {
    return `R$${valor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
    })}`;
  };

  const getBar = (porcentagem) => {
    const largura = porcentagem;
    return (
      <div className="celula-barra">
        <div
          className="barra"
          style={{
            width: `${largura * 0.85}%`,
            backgroundColor: '#898989',
          }}
        />
        <div className="barra-valor">{porcentagem}%</div>
      </div>
    );
  };

  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <div className="tabela-container">
        <table className="tabela">
          <thead>
            <tr key="rh">
              <th className="fixed-header" style={{ width: '20%' }} aria-label="header" key="hn">
                Material Comunicação
              </th>
              <th className="fixed-header" style={{ width: '15%' }} aria-label="header" key="hcm">
                Custo Médio Solicitações
              </th>
              <th className="fixed-header" style={{ width: '15%' }} aria-label="header" key="hct">
                Custo Total
              </th>
              <th className="fixed-header" style={{ width: '15%' }} aria-label="header" key="hts">
                Total Solicitações
              </th>
              <th className="fixed-header" style={{ width: '15%' }} aria-label="header" key="hpa">
                % Aprovada
              </th>
              <th className="fixed-header" style={{ width: '20%' }} aria-label="header" key="hb">
                % Verba Utilizada
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              const { nome } = item;
              return (
                <tr key={`r-${nome}`}>
                  <td key={`in-${nome}`}>{nome}</td>
                  <td key={`icm-${nome}`}>{formatarValor(item.custoMedio)}</td>
                  <td key={`itc-${nome}`}>{formatarValor(item.totalCusto)}</td>
                  <td key={`its-${nome}`}>{item.totalSolicitacoes}</td>
                  <td key={`ipa-${nome}`}>{item.porcentagemAprovada}%</td>
                  <td key={`ivu-${nome}`}>{getBar(item.porcentagemVerba)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MaterialInvestimentoTabela;
